// extracted by mini-css-extract-plugin
export default {"mainLayout":"MainLayout_mainLayout__ouxcz","content":"MainLayout_content__+ilL9"};